import DownloadIcon from "@mui/icons-material/Download";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Modal,
  TextField,
} from "@mui/material";
// import axios from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import { API_URLS } from "../../../config/apiUrls";
import axiosInstance, { baseUrl } from "../../../config/axios";
import SearchAndSelect from "../../../shared/SearchAndSelect";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const ProductVariantByExcel = ({
  open,
  setOpen,
  setCategoryId,
  colorVarient,
  storeVarient,
  otherVarient,
  productId,
  setProductId,
  productData,
  searchParamsManage,
  setSearchParamsManage,
  searchColor,
  setSearchColor,
  searchStorage,
  setSearchStorage,
  searchOther,
  setSearchOther,
}) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [countData, setCountData] = useState({});

  const [type1Value, setType1Value] = useState();
  const [type2Value, setType2Value] = useState();
  const [type3Value, setType3Value] = useState();

  const [color_value_ids, setColor_value_ids] = useState([]);
  const [storage_value_ids, setStorage_value_ids] = useState([]);
  const [other_value_ids, setOther_value_ids] = useState([]);

  const handleModalClose = () => {
    setFile(null);
    setUploading(false);
    setProgress(0);
    setOpen(false);
    setColor_value_ids([]);
    setStorage_value_ids([]);
    setOther_value_ids([]);
    setSearchParamsManage("");
    setSearchColor("");
    setSearchOther("");
    setSearchStorage("");
  };

  const handleValue1 = (e, id) => {
    if (e.target.checked) {
      color_value_ids.push(id);
      setColor_value_ids(color_value_ids);
    } else {
      setColor_value_ids(color_value_ids.filter((elem) => elem !== id));
    }
  };

  const handleValue2 = (e, id) => {
    if (e.target.checked) {
      storage_value_ids.push(id);
      setStorage_value_ids(storage_value_ids);
    } else {
      setStorage_value_ids(storage_value_ids.filter((elem) => elem !== id));
    }
  };
  const handleValue3 = (e, id) => {
    if (e.target.checked) {
      other_value_ids.push(id);
      setOther_value_ids(other_value_ids);
    } else {
      setOther_value_ids(other_value_ids.filter((elem) => elem !== id));
    }
  };
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const updaloadFile = () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      axiosInstance
        .post(`${API_URLS.uploadVariantByExcelApi}`, formData, {
          onUploadProgress: (progressEvent) => {
            const percentage =
              (progressEvent.loaded / progressEvent.total) * 100;
            setProgress(percentage);
          },
        })
        .then((response) => {
          if (response.status === 200) {
            toast.success(response?.data?.message);
            setUploading(true);
            setProgress(100);
            setCountData(response?.data);
          } else {
            toast.warn(response?.data?.message);
          }
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } else {
      toast.error("Please upload a file first.");
    }
  };

  const handleDownload = async () => {
    try {
      const response = await axiosInstance.post(
        `api/admin/sample-format-upload-product-variant-data-admin/`,
        {
          product_id: productId,
          other_value_ids,
          storage_value_ids,
          color_value_ids,
        },
        {
          // method: "POST",
          headers: {
            Token: localStorage.getItem("Token"),
          },
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `sample_product_variant_data.xlsx`;
      a.click();

      URL.revokeObjectURL(url);

      // const blob = await response.blob();
      // const url = window.URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = "sample_product_data.xlsx";
      // a.click();
      // window.URL.revokeObjectURL(url);
      // } else {
      //   throw new Error("Failed to upload product variant data");
      // }
    } catch (error) {
      console.log("AAAAA", error);
      toast.error(error);
    }
  };
  const onSelectProduct = (_, newValue) => {
    setCategoryId(newValue.value2);
    // setProductId(newValue.value2);
  };
  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box
        sx={{ ...style }}
        className="rounded-2xl !border-0 !h-[65vh] overflow-auto"
      >
        <div
          id="child-modal-title "
          className="!text-black !underline !font-bold !pb-3 !text-center !text-xl"
        >
          Product Variant Upload By Excel
        </div>
        <div
          className="relative float-right px-2 font-bold text-black rounded-sm cursor-pointer bottom-16 bg-slate-300 left-6"
          onClick={handleModalClose}
        >
          x
        </div>
        <div className="w-full my-3">
          <div className="mt-3 font-serif">Select Product :</div>
          <SearchAndSelect
            size="small"
            className="mt-1"
            textValue={searchParamsManage}
            setTextValue={setSearchParamsManage}
            value={productId}
            setValue={setProductId}
            onChange={onSelectProduct}
            options={productData?.map((item) => {
              return {
                label: item.title,
                value: item.id,
                value2: item.main_category,
              };
            })}
          />
          {/* <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              size="small"
              className="mt-1"
              onChange={(event) => setCategoryId(event.target.value)}
              name="sub_category_id"
            >
              {categoryData?.map((elem, idx) => (
                <MenuItem key={idx} value={elem?.id}>
                  {elem?.category}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          <div className="w-[100%] py-2">
            <div className="flex justify-around p-2 mt-3 font-bold bg-gray-200 rounded-md">
              <div>
                {colorVarient[0]?.variant_name
                  ? colorVarient[0]?.variant_name + " Value"
                  : "Type One"}
              </div>
              <div>
                {storeVarient[0]?.variant_name
                  ? storeVarient[0]?.variant_name + " Value"
                  : "Type Two"}
              </div>
              <div>
                {otherVarient[0]?.variant_name
                  ? otherVarient[0]?.variant_name + " Value"
                  : "Type Three"}
              </div>
            </div>
            {/* <div className="flex justify-between p-2 font-bold bg-slate-50">
              <div>
                {colorCategoryData && (
                  <Checkbox
                    checked={checked5}
                    onChange={(event) => setChecked5(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                )}

                {colorCategoryData ? colorCategoryData?.length : "--"}
              </div>
              <div>
                {storageCategoryData && (
                  <Checkbox
                    checked={checked6}
                    onChange={(event) => setChecked6(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                )}

                {storageCategoryData?.length}
              </div>
              <div>
                {otherCategoryData && (
                  <Checkbox
                    checked={checked7}
                    onChange={(event) => setChecked7(event.target.checked)}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                )}

                {otherCategoryData?.length}
              </div>
            </div> */}
          </div>
          <div className=" grid grid-cols-3 gap-2 justify-between  mt-2 !bg-[#f9f9fd] p-1">
            <FormControl fullWidth className="">
              <input
                type="text"
                value={searchColor}
                className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                placeholder="Search Type One"
                style={{ border: "1px solid black" }}
                onChange={(event) => setSearchColor(event.target.value)}
              />
              {/* <SearchAndSelect
                size="small"
                className="mt-1"
                textValue={searchColor}
                setTextValue={setSearchColor}
                value={type1Value}
                setValue={(value) => setType1Value(value)}
                // onChange={onSelectColor}
                // options={colorVarient.map((item) => {
                //   return {
                //     label: item.value,
                //     value: item.id,
                //   };
                // })}
              /> */}

              <div className="grid grid-cols-2 gap-0 ">
                {colorVarient &&
                  colorVarient?.map((res, index) => {
                    return (
                      <>
                        <div className="flex">
                          <div className="h-3 w-3">
                            <Checkbox
                              // checked={checked0}
                              size="small"
                              onChange={(event) =>
                                // setChecked0(event.target.checked)
                                handleValue1(event, res.id)
                              }
                              inputProps={{
                                "aria-label": "controlled",
                              }}
                            />
                          </div>
                          <p className="pt-3 ml-6 text-xs">{res?.value}</p>
                        </div>
                      </>
                    );
                  })}
              </div>
            </FormControl>
            {/* <Select
                      mode="multiple"
                      // size="middle"
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={colorVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    />
                    <Select
                      mode="multiple"
                      // size={size}
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={storeVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    />

                    <Select
                      mode="multiple"
                      // size={size}
                      placeholder="Please select"
                      // defaultValue={["a10", "c12"]}
                      // onChange={handleChange}
                      style={{ width: "100%" }}
                      options={otherVarient.map((item) => {
                        return {
                          label: item.value,
                          value: item.id,
                        };
                      })}
                    /> */}

            <FormControl fullWidth>
              {/* <SearchAndSelect
                size="small"
                className="mt-1"
                // name="color"
                textValue={searchStorage}
                setTextValue={setSearchStorage}
                value={type2Value}
                setValue={(value) => setType2Value(value)}
                // onChange={onSelectStorage}
                // options={storeVarient.map((item) => {
                //   return {
                //     label: item.value,
                //     value: item.id,
                //   };
                // })}
              /> */}
              <input
                type="text"
                value={searchStorage}
                className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                placeholder="Search Type Two "
                style={{ border: "1px solid black" }}
                onChange={(event) => setSearchStorage(event.target.value)}
              />
              <div className="grid grid-cols-2 gap-0 ">
                {storeVarient &&
                  storeVarient?.map((res, index) => {
                    return (
                      <>
                        <div className="flex">
                          <div className="h-3 w-3">
                            <Checkbox
                              // checked={checked1}
                              size="small"
                              onChange={(event) =>
                                // setChecked1(event.target.checked)
                                handleValue2(event, res.id)
                              }
                              inputProps={{
                                "aria-label": "controlled",
                              }}
                            />
                          </div>
                          <p className="pt-3 ml-6 text-xs">{res.value}</p>
                        </div>
                      </>
                    );
                  })}
              </div>
            </FormControl>

            <FormControl fullWidth>
              {/* <SearchAndSelect
                size="small"
                className="mt-1"
                name="sub_category_id"
                textValue={searchOther}
                setTextValue={setSearchOther}
                value={type3Value}
                setValue={(value) => setType3Value(value)}
                // onChange={onSelectOther}
                // options={otherVarient.map((item) => {
                //   return {
                //     label: item.value,
                //     value: item.id,
                //   };
                // })}
              /> */}
              <input
                type="text"
                value={searchOther}
                className="!border-1.5 !border-gray-400 mx-3 !w-[96%] p-2 rounded "
                placeholder="Search Type Three"
                style={{ border: "1px solid black" }}
                onChange={(event) => setSearchOther(event.target.value)}
              />
              <div className="grid grid-cols-2 gap-0 ">
                {otherVarient &&
                  otherVarient?.map((res, index) => {
                    return (
                      <>
                        <div className="flex">
                          <div className="h-3 w-3">
                            <Checkbox
                              // checked={checked2}
                              size="small"
                              onChange={(event) =>
                                // setChecked2(event.target.checked)
                                handleValue3(event, res.id)
                              }
                              inputProps={{
                                "aria-label": "controlled",
                              }}
                            />
                          </div>
                          <p className="pt-3 ml-6 text-xs">{res.value}</p>
                        </div>
                      </>
                    );
                  })}
              </div>
            </FormControl>
          </div>
          {/* <div className="flex justify-between h-20 mt-1 !bg-[#f9f9fd] font-bold p-2">
            <div>
              {colorVarient && (
                <Checkbox
                  checked={checked5}
                  size="small"
                  onChange={(event) => setChecked5(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}

              {colorVarient?.length}
            </div>
            <div>
              {storeVarient && (
                <Checkbox
                  checked={checked6}
                  size="small"
                  onChange={(event) => setChecked6(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}

              {storeVarient?.length}
            </div>
            <div>
              {otherVarient && (
                <Checkbox
                  checked={checked7}
                  size="small"
                  onChange={(event) => setChecked7(event.target.checked)}
                  inputProps={{ "aria-label": "controlled" }}
                />
              )}

              {otherVarient?.length}
            </div>
          </div> */}
        </div>

        <div className="flex gap-x-3 pt-6">
          <div className="font-bold text-gray-900">Download Sample</div>
          <div>
            <Button
              variant="contained"
              color="primary"
              className="!bg-blue-500"
              size="small"
              onClick={handleDownload}
            >
              Download <DownloadIcon />
            </Button>
          </div>
        </div>
        <div className="flex gap-x-3">
          <TextField
            size="small"
            id="outlined-basic"
            type="file"
            className="!w-[100%] !mt-3"
            onChange={handleFileChange}
          />
          <Button
            onClick={updaloadFile}
            disabled={uploading === true ? "" : uploading}
            variant="contained"
            type="submit"
            color="success"
            className="!py-2 !px-5 !font-bold !mt-3 !float-right"
          >
            {uploading ? "Uploaded" : "Upload"}
          </Button>
        </div>

        {uploading && (
          <div className="!w-[100%] mt-3">
            <progress value={progress} max="100" className="!w-[90%]" />
            <span className="text-green-500 ">{Math.round(progress)}%</span>
          </div>
        )}
        <br />
        {/* <table className="table w-full">
          <thead>
            <tr>
              <th>Total Count</th>
              <th>Create Count</th>
              <th>Update Count</th>
            </tr>
          </thead>
          <tbody>
            <tr className="text-center text-green-500">
              <th>{countData?.total_data_count} </th>
              <th>{countData?.created_data_count} </th>
              <th>{countData?.updated_data_count} </th>
            </tr>
          </tbody>
        </table> */}
      </Box>
    </Modal>
  );
};

export default ProductVariantByExcel;
